module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"titleAdd":"Associer une destination","labelDestinationToAdd":"Destination à associer","btnAdd":"Associer","btnClose":"Fermer"},"en":{"titleAdd":"Associate a destination","labelDestinationToAdd":"Destination to associate","btnAdd":"Associate","btnClose":"Close"}}')
  delete Component.options._Ctor
}
